/* global show_9513788 */

import { useCallback } from 'react';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import createAdHandler from 'monetag-tg-sdk';

const showMonetagAd = createAdHandler(9513788); // твой zone ID

function generateYmid(userId) {
	return `reward_${userId || 'guest'}_${Date.now()}`;
}

export const useMonetag = ({ onReward, fetchBalance, userId }) => {
	const { t } = useTranslation();

	const showMonetagInterstitial = useCallback(() => {
		const ymid = generateYmid(userId);
		return new Promise((resolve, reject) => {
			showMonetagAd({ ymid })
				.then(() => {
					// Проверяем, не показывали ли уже уведомление для этого ymid
					if (localStorage.getItem(`rewarded_${ymid}`) !== 'true') {
						if (onReward) onReward();
						if (fetchBalance) fetchBalance();
						toast.success(
							t('common.rewardReceived'),
							{
								position: 'top-center',
								autoClose: 2000,
							}
						);
						localStorage.setItem(`rewarded_${ymid}`, 'true');
					}
					resolve();
				})
				.catch((error) => {
					toast.error(t('common.ad_error'));
					reject(error);
				});
		});
	}, [onReward, fetchBalance, t, userId]);

	return showMonetagInterstitial;
}; 